export const GERMAN_MONTHS: Record<string, string> = {
  januar: '01', februar: '02', märz: '03', april: '04', mai: '05', juni: '06',
  juli: '07', august: '08', september: '09', oktober: '10', november: '11', dezember: '12',
}

export function parseGermanDate(value: unknown): { y: number; m: number; d: number } | null {
  const raw = (value == null ? '' : String(value)).trim()
  let y: number, m: number, d: number
  let mo: RegExpExecArray | null
  if ((mo = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(raw))) {
    y = +mo[1]
    m = +mo[2]
    d = +mo[3]
  } else if ((mo = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(raw))) {
    d = +mo[1]
    m = +mo[2]
    y = +mo[3]
  } else if ((mo = /^(\d{1,2})\.?\s+([A-Za-zäöüÄÖÜ]+)\s+(\d{4})$/.exec(raw))) {
    const mm = GERMAN_MONTHS[mo[2].toLowerCase()]
    if (!mm) return null
    d = +mo[1]
    m = +mm
    y = +mo[3]
  } else {
    return null
  }
  const dt = new Date(y, m - 1, d)
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null
  return { y, m, d }
}

export function isValidGermanDate(value: unknown): boolean {
  return parseGermanDate(value) !== null
}

export function toIsoDate(value: string): string {
  const p = parseGermanDate(value)
  return p ? `${p.y}-${String(p.m).padStart(2, '0')}-${String(p.d).padStart(2, '0')}` : value
}
